// extracted by mini-css-extract-plugin
module.exports = {"dotContainer":"StepDots_dotContainer__YXzeU","dot":"StepDots_dot__x9GoY","dotActive":"StepDots_dotActive__scU0Q"};